import React, { useEffect } from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";

interface InputTextAreaProps {
  name: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  handleChange?: (value: string) => void;
  required?: boolean;
}

const InputTextArea: React.FC<InputTextAreaProps> = ({
  name,
  placeholder = "",
  disabled = false,
  rows,
  handleChange,
  required,
}) => {
  const [field, meta] = useField(name);

  useEffect(() => {
    if (handleChange) {
      handleChange(field.value);
    }
  }, [field.value, handleChange]);

  let formClass = "";
  if (meta && meta.touched) {
    if (meta.error) {
      formClass = "is-invalid";
    } else {
      formClass = "is-valid";
    }
  }

  return (
    <>
      <Form.Control
        className={`${formClass}`}
        as="textarea"
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        {...field}
        value={field.value || ""}
        required={required}
      />
      <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
    </>
  );
};

export default InputTextArea;